import Modal from 'common/components/modal/Modal';
import RejectionStatusCd from 'domain/enums/RejectionStatusCd';
import RejectionTypeCd from 'domain/enums/RejectionTypeCd';
import RejectionReason from 'domain/types/RejectionReason';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import ProofContainer from './ProofContainer';
import { GroupReferenceKey } from 'features/cart/CartSlice';

type RejectionActionProps = {
  statusCd: RejectionStatusCd;
  typeCd: RejectionTypeCd;
  typeDescr: string;
  reasons: RejectionReason[];
  groupRefKey: GroupReferenceKey;
};

export const RejectionAction = (props: RejectionActionProps) => {
  const { typeCd, typeDescr, reasons, groupRefKey, statusCd } = props;
  const [show, setShow] = useState(false);
  const { location, push } = useHistory();
  const text = `${typeDescr} - ${reasons.map((r) => r.descr).join(', ')}`;
  let label = null,
    title = '',
    body = null;
  if (
    typeCd === RejectionTypeCd.PRIMARY_RESIDENCE ||
    typeCd === RejectionTypeCd.PRIMARY_RESIDENCE_02
  ) {
    label = (
      <>
        {text}
        <Button variant='link' onClick={() => setShow(true)}>
          {statusCd === RejectionStatusCd.NOT_RESOLVED
            ? '(click here to re-upload)'
            : '(click here to change)'}
        </Button>
      </>
    );
    title = 'Re-upload primary residence';
    body = (
      <>
        <ProofContainer
          groupRefKey={groupRefKey}
          onSuccess={() => setShow(false)}
        />
      </>
    );
  } else if (typeCd === RejectionTypeCd.IDENTITY) {
    label = (
      <>
        {text}
        <Button
          variant='link'
          onClick={() =>
            push('/profile#identity-verification', {
              onReupload: {
                to: location.pathname,
                message: 'Identity has been re-uploaded.',
                linkText: 'Return to application to resubmit.',
              },
            })
          }
        >
          {statusCd === RejectionStatusCd.NOT_RESOLVED
            ? '(click here to re-upload)'
            : '(click here to change)'}
        </Button>
      </>
    );
  } else if (typeCd === RejectionTypeCd.SHUOL) {
    label = (
      <>
        {text}
        {statusCd === RejectionStatusCd.NOT_RESOLVED && (
          <Link
            className='ml-3'
            to={{
              pathname: '/profile',
              hash: '#shuol',
              state: {
                onSuccess: {
                  to: location.pathname,
                  message: 'SHUOL has been updated.',
                  linkText: 'Return to application to resubmit.',
                },
              },
            }}
          >
            (click here to enter)
          </Link>
        )}
      </>
    );
  } else {
    label = text;
  }

  return (
    <>
      <Modal
        show={show}
        toggle={() => setShow(false)}
        title={<h3>{title}</h3>}
        body={<>{body}</>}
      />
      {label}
    </>
  );
};
